<script setup>

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 26 26"><path d="M20 3a4 4 0 0 0-3.858 3H8V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8h4.388a3.937 3.937 0 0 0-.42.993l-1.868 6.49A2.007 2.007 0 0 1 8.16 17H8v-1a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1h.16a4 4 0 0 0 3.87-2.993l1.87-6.49A2.007 2.007 0 0 1 15.84 8h.3A3.993 3.993 0 1 0 20 3zM2 9V5h4v4zm0 11v-4h4v4zM20 9a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path></svg>
</template>

<style scoped>

</style>